<style lang="less">
    .disable {
        cursor: no-drop !important;
        opacity: 0.4;
    }
</style>

<i18n>
{
  "zh": {
    "table": "表格",
    "picture": "图片",
    "note": "注释",
    "hyperlink": "超链接",
    "attach": "附件",
    "comment": "评论",
    "chart": "图表",
    "mathEquation": "数学公式",
    "QRCode": "二维码",
    "watermark": "水印",
    "container": "容器",
    "matrix": "矩阵",
    "tableUnit": "表格单元",
    "map": "地图",
    "entity": "实体",
    "multiBlock": "表格容器",
    "timeline": "时间线",
    "aiDraw": "AI图片",
    "insertSomething": "选中元素后，才能进行插入操作"
  },
  "en": {
    "table": "Table",
    "picture": "Image",
    "note": "Note",
    "hyperlink": "Hyperlink",
    "attach": "Attachment",
    "comment": "Comment",
    "chart": "Chart",
    "mathEquation": "Math Equation",
    "QRCode": "QR Code",
    "watermark": "Watermark",
    "container": "Container",
    "matrix": "Matrix",
    "tableUnit": "Table Unit",
    "map": "Map",
    "entity": "Entity",
    "multiBlock": "Form Container",
    "timeline": "Timeline",
    "aiDraw": "AI Drawing",
    "insertSomething": "You can only perform the insert operation after selecting an element."
  },
  "fr": {
    "table": "Table",
    "picture": "Image",
    "note": "Remarque",
    "hyperlink": "Hyperlien",
    "attach": "Attachement",
    "comment": "Commentaire",
    "chart": "Graphique",
    "mathEquation": "Équation mathématique",
    "QRCode": "Code QR",
    "watermark": "Filigrane",
    "container": "Récipient",
    "matrix": "Matrice",
    "tableUnit": "Unité de table",
    "map": "Carte",
    "entity": "Entité",
    "multiBlock": "Conteneur de formulaire",
    "timeline": "Chronologie",
    "aiDraw": "Dessin AI",
    "insertSomething": "Vous ne pouvez effectuer l'opération d'insertion qu'après avoir sélectionné un élément"
  },
  "de": {
    "table": "Tabelle",
    "picture": "Bild",
    "note": "Notiz",
    "hyperlink": "Hyperlink",
    "attach": "Anhang",
    "comment": "Kommentar",
    "chart": "Diagramm",
    "mathEquation": "Mathematische Formel",
    "QRCode": "QR Kode",
    "watermark": "Wasserzeichen",
    "container": "Behälter",
    "matrix": "Matrix",
    "tableUnit": "Tabelleneinheit",
    "map": "Landkarte",
    "entity": "Entität",
    "multiBlock": "Formularcontainer",
    "timeline": "Zeitachse",
    "aiDraw": "AI Drawing",
    "insertSomething": "Sie können erst nach Auswahl eines Elements das Einfügen durchführen"
  },
  "jp": {
    "table": "表",
    "picture": "画像",
    "note": "注釈",
    "hyperlink": "ハイパーリンク",
    "attach": "アタッチメント",
    "comment": "コメント",
    "chart": "チャート",
    "mathEquation": "数式",
    "QRCode": "QRコード",
    "watermark": "透かし",
    "container": "容器",
    "matrix": "マトリックス",
    "tableUnit": "テーブルセル",
    "map": "マップ",
    "entity": "エンティティ",
    "multiBlock": "表の容器",
    "timeline": "タイムライン",
    "aiDraw": "AI描画",
    "insertSomething": "挿入の前に、要素を選択してください。"
  },
  "es": {
    "table": "Mesa",
    "picture": "Imagen",
    "note": "Nota",
    "hyperlink": "Hipervínculo",
    "attach": "Adjunto",
    "comment": "Contenedor",
    "chart": "Gráfico",
    "mathEquation": "Ecuación matemática",
    "QRCode": "Código QR",
    "watermark": "Marca de agua",
    "container": "Contenedor",
    "matrix": "Matrix",
    "tableUnit": "Unidad de mesa",
    "map": "Mapa",
    "entity": "Entidad",
    "multiBlock": "Contenedor de formularios",
    "timeline": "Cronología",
    "aiDraw": "Dibujo de AI",
    "insertSomething": "Solo puedes realizar la operación de inserción después de seleccionar un elemento"
  },
  "pt": {
    "table": "Tabela",
    "picture": "Imagem",
    "note": "Nota",
    "hyperlink": "Hiperligação",
    "attach": "Anexo",
    "comment": "Comentário",
    "chart": "Gráfico",
    "mathEquation": "Equação Matemática",
    "QRCode": "Código QR",
    "watermark": "Marca de Água",
    "container": "Contêiner",
    "matrix": "Matriz",
    "tableUnit": "Unidade de Tabela",
    "map": "Mapa",
    "entity": "Entidade",
    "multiBlock": "De Contêiner",
    "timeline": "Linha do tempo",
    "aiDraw": "Desenho por IA",
    "insertSomething": ""
  },
  "it": {
    "table": "Tabella",
    "picture": "Immagine",
    "note": "Nota",
    "hyperlink": "Collegamento",
    "attach": "Attaccamento",
    "comment": "Commento",
    "chart": "Diagramma",
    "mathEquation": "Equazione Matematica",
    "QRCode": "Codice QR",
    "watermark": "Filigrana",
    "container": "Contenitore",
    "matrix": "Matrice",
    "tableUnit": "Unità Tabella",
    "map": "Mappa",
    "entity": "Entità",
    "multiBlock": "Contenitore Forma",
    "timeline": "Sequenza temporale",
    "aiDraw": "Disegno AI",
    "insertSomething": "È possibile eseguire l'operazione di inserimento solo dopo aver selezionato un elemento"
  },
  "tw": {
    "table": "表格",
    "picture": "圖片",
    "note": "注釋",
    "hyperlink": "超連結",
    "attach": "附件",
    "comment": "評論",
    "chart": "圖表",
    "mathEquation": "數學公式",
    "QRCode": "二維碼",
    "watermark": "水印",
    "container": "容器",
    "matrix": "矩陣",
    "tableUnit": "表格單元",
    "map": "地圖",
    "entity": "實體",
    "multiBlock": "表格容器",
    "timeline": "時間線",
    "aiDraw": "AI 繪圖",
    "insertSomething": "您必須先選取一個元素，才能執行插入操作"
  }
}
</i18n>
<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" :showTippy="false" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import appConfig from "@/public/globalConfig";
    import MenuList from "@/app/components/MenuList.vue";
    import InsertDropsMixins from "./insertDropsMixins";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            MenuList,
        },
    })
    export default class InsertDrops extends InsertDropsMixins {
        tempDisable = !appConfig.isBuild;
        workerURL: string = appConfig.workerURL;
        libraryWorkerURL: string = appConfig.libraryWorkerURL;

        get menuList() {
            let list = [
                {
                    key: "note",
                    shortcut: "Ctrl+Alt+Z",
                    extraClass: this.activeFunc == "insertNote" && "activeFunc",
                },
                {
                    key: "comment",
                    shortcut: "Ctrl+Alt+X",
                    extraClass: this.activeFunc == "insertComment" && "activeFunc",
                },
                {
                    key: "hyperlink",
                    shortcut: "Ctrl+K",
                    extraClass: this.activeFunc == "insertHylink" && "activeFunc",
                },
                {
                    key: "attach",
                    shortcut: "Ctrl+H",
                    extraClass: this.activeFunc == "insertAttach" && "activeFunc",
                },
                { divide: true },
                {
                    key: "picture",
                    shortcut: "Ctrl+Alt+I",
                    extraClass: this.activeFunc == "insertImage" && "activeFunc",
                },
                { key: "aiDraw", isRender: window.EDCONFIG.AI.DRAW_ENABLE },
                // { key: "svg", shortcut: "Ctrl+Alt+S", isRender: this.tempDisable },
                {
                    key: "table",
                    shortcut: "Ctrl+Alt+T",
                    extraClass: this.activeFunc == "insertTable" && "activeFunc",
                },
                {
                    key: "chart",
                    shortcut: "Ctrl+Alt+P",
                    extraClass: this.activeFunc == "insertChart" && "activeFunc",
                },
                {
                    key: "timeline",
                    extraClass: this.activeFunc == "insertTimeline" && "activeFunc",
                },
                {
                    key: "map",
                    shortcut: "Ctrl+Alt+M",
                    isRender: this.internal,
                    extraClass: this.activeFunc == "insertMap" && "activeFunc",
                },
                {
                    key: "mathEquation",
                    shortcut: "Ctrl+Alt+E",
                    extraClass: this.activeFunc == "insertMath" && "activeFunc",
                },
                { divide: true },
                {
                    key: "QRCode",
                    shortcut: "Ctrl+Alt+Q",
                    extraClass: this.activeFunc == "insertQRCode" && "activeFunc",
                },
                {
                    key: "watermark",
                    extraClass: this.activeFunc == "insertWaterMark" && "activeFunc",
                },
                { divide: true },
                {
                    key: "container",
                    extraClass: this.activeFunc == "insertContainer" && "activeFunc",
                    isRender: !window.EDCONFIG.IS_SDK,
                },
                { key: "matrix", isRender: this.tempDisable },
                { key: "tableUnit", isRender: this.tempDisable },
                { key: "entity", isRender: this.tempDisable },
                { key: "multiBlock", isRender: this.tempDisable },
            ];

            let resultList = [];
            list.filter((i) => (i.hasOwnProperty("isRender") ? i.isRender : true)).map((item) => {
                resultList.push(item.divide ? item : Object.assign({}, item, { label: this.$t(item.key) }));
            });
            return { container: "insert-drops", list: resultList };
        }
        handleClicks(...args) {
            let key = args[0],
                event = args[1];
            let clickEvents = new Map([
                [
                    "note",
                    () => {
                        event.stopPropagation();
                        this.showContentByKey("note");
                    },
                ],
                [
                    "comment",
                    () => {
                        event.stopPropagation();
                        this.showContentByKey("comment");
                    },
                ],
                [
                    "hyperlink",
                    () => {
                        event.stopPropagation();
                        this.showHyper();
                    },
                ],
                [
                    "attach",
                    () => {
                        event.stopPropagation();
                        this.showContentByKey("attach");
                    },
                ],
                [
                    "picture",
                    () => {
                        event.stopPropagation();
                        this.showImage();
                    },
                ],
                [
                    "aiDraw",
                    () => {
                        event.stopPropagation();
                        this.showAIDraw();
                    },
                ],
                // [ "svg", () => { event.stopPropagation() }],
                [
                    "table",
                    () => {
                        event.stopPropagation();
                        this.showTable();
                    },
                ],
                [
                    "chart",
                    () => {
                        event.stopPropagation();
                        this.showEChart();
                    },
                ],
                [
                    "timeline",
                    () => {
                        event.stopPropagation();
                        this.showTimeline(event);
                    },
                ],
                [
                    "map",
                    () => {
                        event.stopPropagation();
                        this.showMap();
                    },
                ],
                [
                    "mathEquation",
                    () => {
                        event.stopPropagation();
                        this.showMath();
                    },
                ],
                [
                    "QRCode",
                    () => {
                        event.stopPropagation();
                        this.showQRCode();
                    },
                ],
                [
                    "watermark",
                    () => {
                        event.stopPropagation();
                        this.showWaterMark();
                    },
                ],
                [
                    "container",
                    () => {
                        event.stopPropagation();
                        this.insertContainer(event);
                    },
                ],
                [
                    "matrix",
                    () => {
                        event.stopPropagation();
                        this.insertMatrix(event);
                    },
                ],
                [
                    "tableUnit",
                    () => {
                        event.stopPropagation();
                        this.insertTableUnit(event);
                    },
                ],
                [
                    "entity",
                    () => {
                        event.stopPropagation();
                        this.insertEntity(event);
                    },
                ],
                [
                    "multiBlock",
                    () => {
                        event.stopPropagation();
                        this.insertMultiBlock();
                    },
                ],
            ]);
            const onClicks = clickEvents.get(key);
            onClicks && onClicks();
        }
        showChart(e: MouseEvent) {
            let node = <HTMLElement>e.target;
            let scrollTop = node.parentElement.scrollTop;
            let ts: any = this;
            ts.$bus.$emit("changeDropType", "Chart", node.offsetTop - scrollTop);
            this.showExpand();
        }
        showTimeline(e: MouseEvent) {
            this.$emit("closeDrop");
            this.$track("menu", "insert", "timeline");
            this.sensors.track("openTimelineInsertWindow", {
                Catalogues: "SpecificDiagrams",
            });

            const TIMELINE_GROUPID = 92,
                TIMELINE_TABLEID = 279,
                PROTIMELINE_GROUPID = 28,
                PROTIMELINE_TABLEID = 390;

            const TIMELINE_GROUPNAME = "Timeline",
                PROTIMELINE_GROUPNAME = "Project Timeline";
            let menu = this.$store.state.library.menuList,
                DBName = "",
                TBName = "",
                versionObj = null,
                url = "",
                proDBName = "",
                proTBName = "",
                proversionObj = null,
                prourl = "";
            for (let i = 0; i < menu.length; i++) {
                if (menu[i].id == TIMELINE_GROUPID) {
                    DBName = menu[i].groupName;
                    let tables = menu[i].children;
                    for (let j = 0; j < tables.length; j++) {
                        if (tables[j].id == TIMELINE_TABLEID) {
                            TBName = tables[j].tableName;
                            versionObj = {
                                tableID: TIMELINE_TABLEID,
                                name: TBName,
                                version: tables[j].version,
                                type: tables[j].type,
                                group: DBName,
                                mcount: tables[j].mcount,
                            };
                            url = tables[j].url;
                            break;
                        } else if (tables[j].tableName == TIMELINE_GROUPNAME) {
                            // 备用方案，以防tableID发生更改
                            TBName = TIMELINE_GROUPNAME;
                            versionObj = {
                                tableID: tables[j].id,
                                name: TBName,
                                version: tables[j].version,
                                type: tables[j].type,
                                group: DBName,
                                mcount: tables[j].mcount,
                            };
                            url = tables[j].url;
                            break;
                        }
                    }
                } else if (menu[i].id == PROTIMELINE_GROUPID) {
                    proDBName = menu[i].groupName;
                    let tables = menu[i].children;
                    for (let j = 0; j < tables.length; j++) {
                        if (tables[j].id == PROTIMELINE_TABLEID) {
                            proTBName = tables[j].tableName;
                            proversionObj = {
                                tableID: PROTIMELINE_TABLEID,
                                name: proTBName,
                                version: tables[j].version,
                                type: tables[j].type,
                                group: proDBName,
                                mcount: tables[j].mcount,
                            };
                            prourl = tables[j].url;
                            break;
                        } else if (tables[j].tableName == PROTIMELINE_GROUPNAME) {
                            // 备用方案，以防tableID发生更改
                            proTBName = PROTIMELINE_GROUPNAME;
                            proversionObj = {
                                tableID: tables[j].id,
                                name: proTBName,
                                version: tables[j].version,
                                type: tables[j].type,
                                group: proDBName,
                                mcount: tables[j].mcount,
                            };
                            prourl = tables[j].url;
                            break;
                        }
                    }
                }
            }
            let checkDBVersion = (versionObj) => {
                // 检查符号库的版本
                return new Promise((res, rej) => {
                    let opendb = self.indexedDB.open("versionDB");
                    opendb.onsuccess = (e) => {
                        // 检查是否下载库
                        let db = opendb.result;
                        let trans = db.transaction("version", "readwrite");
                        let objstore = trans.objectStore("version");

                        var index = objstore.index("tableIDIndex");
                        index.get(versionObj.tableID).onsuccess = (e) => {
                            let data = (e.target as IDBRequest).result;
                            if (data) {
                                // 有数据且版本不一致 需要更新
                                if (data.version !== versionObj.version || data.group !== versionObj.group) res("update");
                                else rej();
                            } else {
                                res("new");
                            }
                            db.close();
                        };
                    };
                });
            };
            let processList = [0, 0];
            let successList = [false, false];
            let downloadDB = (DBName, tableName, url, versionObj, type, index) => {
                return new Promise((rs, rj) => {
                    let worker = new Worker(this.libraryWorkerURL);
                    worker.postMessage({
                        type: type,
                        lang: appConfig.language,
                        urls: this.urls,
                        data: {
                            DBName,
                            tableName,
                            url,
                            versionObj,
                        },
                    });
                    worker.onmessage = (e) => {
                        let message = e.data;
                        if (message.type === "download error") {
                            successList[index] = true;
                            if (successList[0] && successList[1]) this.toggleLoading(false);
                            worker.terminate();
                        }
                        if (message.type === "loaded" || message.type === "data is lastest") {
                            successList[index] = true;
                            processList[index] = 0.5;
                            if (successList[0] && successList[1]) this.toggleLoading(false);
                            worker.terminate();
                            rs();
                        }
                        if (message.type === "process") {
                            processList[index] = message.process * 0.5;
                            console.log("process " + index + processList[index]);
                            this.setProcess(processList[0] + processList[1]);
                        }
                    };
                });
            };

            let list = [];
            let p1 = new Promise((rs, rj) => {
                checkDBVersion(versionObj)
                    .then((type) => {
                        this.toggleLoading(true, "library");
                        downloadDB(DBName, TBName, url, versionObj, type, 0).then((e) => {
                            rs();
                        });
                    })
                    .catch((e) => {
                        processList[0] = 0.5;
                        successList[0] = true;
                        if (successList[0] && successList[1]) this.toggleLoading(false);
                        rs();
                    });
            });
            let p2 = new Promise((rs, rj) => {
                checkDBVersion(proversionObj)
                    .then((type) => {
                        this.toggleLoading(true, "library");
                        downloadDB(proDBName, proTBName, prourl, proversionObj, type, 1).then((e) => {
                            rs();
                        });
                    })
                    .catch((e) => {
                        processList[1] = 0.5;
                        successList[1] = true;
                        if (successList[0] && successList[1]) this.toggleLoading(false);
                        rs();
                    });
            });
            list.push(p1);
            list.push(p2);
            Promise.all(list)
                .then((e) => {
                    this.showDialog("InsertTimeline");
                })
                .catch((e) => {
                    // 不需要更新
                    this.showDialog("InsertTimeline");
                });
        }
        insertContainer(e: MouseEvent) {
            this.$emit("closeDrop");
            // let view = window['_view'];
            // if(!view) return;
            // view.createContainer();

            this.insertContainerHandler();
        }
        insertMatrix(e: MouseEvent) {
            this.$emit("closeDrop");
            let view = window["_view"];
            if (!view) return;
            view.createMatrix();
        }
        insertTableUnit(e: MouseEvent) {
            this.$emit("closeDrop");
            let view = window["_view"];
            if (!view) return;
            view.createTableUnit();
        }
        insertEntity(e: MouseEvent) {
            this.$emit("closeDrop");
            let view = window["_view"];
            if (!view) return;
            view.createEntity();
        }
        insertMultiBlock() {
            this.$emit("closeDrop");
            let view = window["_view"];
            if (!view) return;
            view.createMultiBlock();
        }

        showExpand() {
            this.$store.commit("setStatus", {
                type: "showDropExpand",
                data: true,
            });
        }
        showTable() {
            this.$emit("closeDrop");
            this.$track("menu", "insert", "table");
            this.showDialog("InsertTable");
        }
        showEChart() {
            this.$emit("closeDrop");
            this.$track("menu", "insert", "chart");
            this.sensors.track("openChartInsertWindow", {
                Catalogues: "SpecificDiagrams",
            });
            this.showDialog("InsertEChart");
        }
        showWaterMark() {
            this.$emit("closeDrop");
            this.$track("menu", "insert", "watermark");
            this.showDialog("InsertWaterMark");
        }
        showMap() {
            this.$emit("closeDrop");
            this.$track("menu", "insert", "map");
            this.sensors.track("openMapInsertWindow", {
                Catalogues: "SpecificDiagrams",
            });

            this.showMapHandler();
        }
        // addPicture(e:MouseEvent){
        //     this.$store.commit('setStatus',{
        //         type:'showDropdown',
        //         data: false
        //     })
        //         let view = window["_view"];
        //         if(!(<HTMLInputElement>e.srcElement).files.length || !view) return;
        //         view.insertImageFromFile((<HTMLInputElement>e.srcElement).files[0]);
        // }
        showMath() {
            this.$emit("closeDrop");
            this.$track("menu", "insert", "math");
            this.sensors.track("openFormulaEditor", {
                Catalogues: "SpecificFunctions",
            });
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "Math",
            });
        }

        showContentByKey(key: string) {
            if (!this.canInsert) {
                this.$edMessage.warning(this.$t("insertSomething"));
                return;
            }
            this.$track("menu", "insert", key);
            this.$emit("closeDrop");
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: key,
            });
        }

        showHyper() {
            if (!this.canInsert) {
                this.$edMessage.warning(this.$t("insertSomething"));
                return;
            }
            this.$emit("closeDrop");
            this.$track("menu", "insert", "hyperlink");

            let view = window["_view"];
            if (view._activeShape && view._activeShape.toGantt()) {
                let gantt = view._activeShape.toGantt();
                let vecSels = [];
                gantt.getSelectedTasks(vecSels);
                if (vecSels.length != 0) {
                    let vecCols = gantt.getColumnArrayByType(13); //Hyperlink
                    if (vecCols.length != 0) {
                        gantt._taskIdColIdPair.first = vecSels[0]._id;
                        gantt._taskIdColIdPair.second = vecCols[0]._colId;
                    }
                }
            }

            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "hyperlink",
            });
        }

        showImage() {
            this.$emit("closeDrop");
            this.$track("menu", "insert", "image");
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "imageModel",
            });
        }
        showAIDraw() {
            this.$emit("closeDrop");
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "AIDraw",
            });
        }
        showQRCode() {
            this.$emit("closeDrop");
            this.$track("menu", "insert", "qrcode");
            this.showDialog("InsertQRCode");
        }

        get canInsert() {
            return this.$store.state.shape.isActived && !this.$store.state.shape.isMultiSel && !this.$store.state.shape.isLine;
        }
        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }

        mounted() {}

        created() {}
    }
</script>
